import faxDocumentTypes from './fax-document-types';

export default function FaxDocumentTypeFilter() {
    return function(input) {
        const type = _.find(faxDocumentTypes, {id: input});
        return type ? type.shortName : input;
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-document-filter.js